import { reducer as satisfactionReducer } from './satisfaction.slice';

export default satisfactionReducer;
